import { useTranslation } from 'react-i18next'
import { Button, KIND, SIZE } from 'baseui/button'
import usePdlSearchV2 from './usePdlSearchV2'
import useRetrievePDLsV2 from './useRetrievePDLsV2'
import SearchResultsModal from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/SearchResultsModal'
import SearchResultsTable from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/SearchResultsTable'
import useSearchResultsPagination from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useSearchResultsPagination'
import CounterBadge from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/CounterBadge'

const PdlSearchResults = () => {
  const { t } = useTranslation()

  const {
    searchPodResponses,
    handlePageChange,
    page,
    handleSelectPdl,
    handleBackToSearch,
  } = usePdlSearchV2()
  const { errorMessage } = useRetrievePDLsV2()

  const resultsPerPage = 8
  const currentPage = page
  const { totalPages, paginatedResults } = useSearchResultsPagination(
    searchPodResponses, 
    resultsPerPage, 
    currentPage
  )

  const columns = [
    t('subscriptionTools:pdl_search.result_table_head.row_pdl'),
    t('subscriptionTools:pdl_search.result_table_head.row_address_name'),
    t('subscriptionTools:pdl_search.result_table_head.row_address_location'),
    t('subscriptionTools:pdl_search.result_table_head.row_address_complement'),
    t('subscriptionTools:pdl_search.result_table_head.row_final_client'),
    t('subscriptionTools:pdl_search.result_table_head.row_counter'),
    t('subscriptionTools:pdl_search.result_table_head.row_serial_number'),
    t('subscriptionTools:pdl_search.result_table_head.row_matricule'),
    t('subscriptionTools:pdl_search.result_table_head.row_choose'),
  ]

  const tableData = paginatedResults.map(item => {
    return [
      item.pdl || item.pod_id || '-',
      item.addressName || '-',
      item.addressLocation || '-',
      item.addressComplement2 || '-',
      item.finalClient || '-',
      <CounterBadge pdlType={item.pdlType} pdlState={item.pdlState} />,
      item.pdlId || '-',
      item.matricule || '-',
      <Button size={SIZE.mini} kind={KIND.primary} onClick={() => handleSelectPdl(item)}>
        {t('subscriptionTools:pdl_search.result_table_head.row_choose')}
      </Button>,
    ]
  })

  if (errorMessage) {
    return (
      <SearchResultsModal
        title={t('subscriptionTools:pdl_search.results_error.error_text')}
        message={errorMessage}
        isError={true}
        onBackToSearch={handleBackToSearch}
        backButtonText={t('subscriptionTools:pdl_search.modify_search')}
      />
    )
  }

  if (!searchPodResponses.length) {
    return (
      <SearchResultsModal
        title={t('subscriptionTools:pdl_search.no_results')}
        message={t('subscriptionTools:pdl_search.modify_search')}
        onBackToSearch={handleBackToSearch}
        backButtonText={t('subscriptionTools:pdl_search.modify_search')}
      />
    )
  }

  return (
    <SearchResultsTable
      columns={columns}
      data={tableData}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      onBackToSearch={handleBackToSearch}
      backButtonText={t('subscriptionTools:pdl_search.back_to_search')}
      t={t}
      translationPrefix="subscriptionTools:pdl_search"
    />
  )
}

export default PdlSearchResults
